import React from 'react'
import clsx from 'clsx'
import TopBanner from './TopBanner'
import useStyles from './_styles'
import { useAppSelector } from '../../store'

export default function Container({ topBanner, bottomActions, noBackground, children }: any) {
    const healthCareService = useAppSelector((state) => state.healthCareService)
    const classes = useStyles()

    return (
        <div className={classes.Container}>
            <div className={classes.ContainerTop}>
                {/* @ts-expect-error TS(2322) FIXME: Type '{ healthCareService: any; }' is not assignab... Remove this comment to see the full error message */}
                {topBanner && <TopBanner healthCareService={healthCareService} />}
            </div>
            <div className={clsx(classes.ContainerContent, noBackground && classes.ContainerContentNoBackground)}>
                {children}
            </div>
            {/* @ts-expect-error TS(2322) FIXME: Type '{ healthCareService: any; }' is not assignab... Remove this comment to see the full error message */}
            {bottomActions && <div className={classes.ContainerBottomActions}>{bottomActions}</div>}
        </div>
    )
}
